export default "__VITE_ASSET__zzalVBwK__"